import type { IUpdatedFRAttachment } from "models/HaulPay";

const IMAGE_MIME_BY_EXTENSION: Record<string, string> = {
  gif: "image/gif",
  heic: "image/heic",
  heif: "image/heif",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  png: "image/png",
  webp: "image/webp"
};

const getExtension = (file?: IUpdatedFRAttachment) => {
  const type = file?.type?.toLowerCase().replace(/^image\//, "");
  if (type && IMAGE_MIME_BY_EXTENSION[type]) return type;
  return file?.filename.split(".").pop()?.toLowerCase() ?? "";
};

export const resolveAttachmentMimeType = (file: IUpdatedFRAttachment, responseMimeType: string) => {
  if (responseMimeType.startsWith("image/")) return responseMimeType;

  const extension = getExtension(file);
  if (IMAGE_MIME_BY_EXTENSION[extension]) return IMAGE_MIME_BY_EXTENSION[extension];
  if (extension === "pdf") return "application/pdf";
  return responseMimeType;
};
